import Logins from '../Application/Authentication/Login/Screen/Login';
import ForgetPassword from "../Application/Authentication/Login/Screen/ForgetPassword";
import TwoFactorVerification from "../Application/Authentication/TwoFactorAuth";

export const authRoutes = [
    {path: `${process.env.PUBLIC_URL}/login`, Component: <Logins/>},
    {path: `${process.env.PUBLIC_URL}/verify-2fa`, Component: <TwoFactorVerification/>},
    {path: `${process.env.PUBLIC_URL}/forget-password`, Component: <ForgetPassword/>},
];
